import { UserOrganizationInvitationResponse } from "../../../api-models/response/organization/OrganizationDetailsResponse";
import { RowItemData } from "../../../components/datatable/interfaces";
import { OrganizationInvitationStatuses } from "../../../generated/OrganizationInvitations";
import dateService from "../../date-service/DateService";
import { translationService } from "../../translation/TranslationService";
import { EmploymentStatus } from "../EmploymentStatus";
import { Role } from "../Role";

export class UserOrganizationInvitation implements RowItemData {
  id: number;
  name: string;
  invitationStatus: OrganizationInvitationStatuses;
  private created: Date;
  private contactName: string;
  private email: string;
  private phone: string;
  private employmentStatus: EmploymentStatus;
  private role: string;

  constructor(userOrganizationInvitationResponse: UserOrganizationInvitationResponse) {
    this.id = userOrganizationInvitationResponse.id;
    this.name = userOrganizationInvitationResponse.organizationDetails.name;
    this.invitationStatus = userOrganizationInvitationResponse.organizationInvitationStatus;
    this.created = userOrganizationInvitationResponse.created;
    this.contactName = userOrganizationInvitationResponse.organizationDetails.contact.name;
    this.email = userOrganizationInvitationResponse.organizationDetails.email;
    this.phone = userOrganizationInvitationResponse.organizationDetails.phone;
    this.employmentStatus = new EmploymentStatus(
      userOrganizationInvitationResponse.employmentStatus
    );
    this.role = new Role(userOrganizationInvitationResponse.role).translationKey;
  }

  get displayValues() {
    return {
      name: { toDisplay: this.name },
      created: { toDisplay: dateService.formatDate(this.created) },
      contact: { toDisplay: this.contactName },
      email: { toDisplay: this.email },
      phone: { toDisplay: this.phone },
      employmentStatus: {
        toDisplay: this.employmentStatus.displayName,
      },
      role: { toDisplay: translationService.translate(this.role) },
      organizationInvitationStatus: {
        toDisplay: translationService.translate(
          `api.organization.invitation.status.${
            OrganizationInvitationStatuses[this.invitationStatus]
          }`
        ),
      },
    };
  }
}
